module.exports = __webpack_public_path__ + "static/media/WSB_logo_black.2a7a851d.png";